import { observer } from "mobx-react-lite";
import { Icon } from "~/components/Icon";
import { Spacer } from "~/components/Spacer";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";

export const Note = observer(function Note({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <View
      flexDirectionRow
      alignItemsCenter
      paddingVerticalSmall
      paddingHorizontalLarge
      colorBackgroundLight
      borderRadiusSmall
    >
      <View>
        <Icon
          name="exclamation-mark"
          color={styleConstants.colorBackgroundDark}
          size={24}
        />
      </View>
      <Spacer large />
      <View flex>{children}</View>
    </View>
  );
});
